import {registerTemplateGraphNode} from "#template/template-node/register"
import {pointGeometryAttributeLike, pointGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {PointGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {BinaryMathOperatorParameters} from "#template/nodes/geometry-graph/attribute/binary-math-operator/geometry-binary-math-operator-node"
import {
    GeometryBinaryMathOperatorNode,
    binaryMathOperatorParametersSchema,
} from "#template/nodes/geometry-graph/attribute/binary-math-operator/geometry-binary-math-operator-node"

export type PointGeometryBinaryMathOperatorParameters = BinaryMathOperatorParameters<PointGeometryAttributeLikeNode>

const definition: TemplateNodeDefinition<PointGeometryBinaryMathOperatorParameters> = {
    nodeClass: "PointGeometryBinaryMathOperator",
    validation: {
        parameters: binaryMathOperatorParametersSchema(pointGeometryAttributeLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class PointGeometryBinaryMathOperator
    extends GeometryBinaryMathOperatorNode<0, PointGeometryAttributeLikeNode>
    implements PointGeometryAttributeLikeNode
{
    get [pointGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
